import {
  eligibleJackpotActionTypes,
  eligibleJackpotsActions,
  EligibleJackpotsState,
} from "@/fe-core/meta/types/eligibleJackpots";
import { RootActions, rootActionTypes } from "@/fe-core/meta/types/root";

const initialState: EligibleJackpotsState = {
  pending: false,
  status: null,
  jackpots: null,
  showJackpotModal: false,
};

const eligibleJackpotsReducer = (
  state: EligibleJackpotsState = initialState,
  action: eligibleJackpotsActions | RootActions
): EligibleJackpotsState => {
  switch (action.type) {
    case eligibleJackpotActionTypes.GET_ELIGIBLE_JACKPOTS_REQUEST:
      return {
        ...state,
        pending: true,
        status: null,
      };
    case eligibleJackpotActionTypes.GET_ELIGIBLE_JACKPOTS_SUCCESS:
      return {
        ...state,
        pending: false,
        jackpots: action.payload,
        status: {
          success: true,
          message: "",
        },
      };
    case eligibleJackpotActionTypes.GET_ELIGIBLE_JACKPOTS_FAILURE:
      const {
        payload: { message: eligibleJackpotsMessage },
      } = action;
      return {
        ...state,
        pending: false,
        status: {
          success: false,
          message: eligibleJackpotsMessage,
        },
      };

    case eligibleJackpotActionTypes.UPDATE_JACKPOTS_DATA:
      return {
        ...state,
        jackpots: state.jackpots?.find(
          (jackpot) => jackpot?.name === action.payload.name
        )
          ? state.jackpots?.map((jackpot) =>
              jackpot.name === action.payload.name
                ? {
                    ...jackpot,
                    ...action.payload,
                    jackpotAmount: action.payload.tiers.reduce(
                      (acc, tier) => acc + tier.value,
                      0
                    ),
                  }
                : jackpot
            ) || null
          : [action.payload],
      };

    case eligibleJackpotActionTypes.OPEN_JACKPOT_MODAL:
      return {
        ...state,
        showJackpotModal: true,
      };

    case eligibleJackpotActionTypes.CLOSE_JACKPOT_MODAL:
      return {
        ...state,
        showJackpotModal: false,
      };

    case rootActionTypes.CLEAR_STATE:
      return {
        ...initialState,
      };

    default:
      return {
        ...state,
      };
  }
};

export default eligibleJackpotsReducer;
